/** Max width of the phone-style app frame (centered on desktop). */
export const MOBILE_APP_FRAME_MAX_W = "430px";

/** Shared fixed positioning inside the centered mobile frame. */
export const mobileFrameFixedSx = {
  position: "fixed",
  left: "50%",
  transform: "translateX(-50%)",
  width: "100%",
  maxW: MOBILE_APP_FRAME_MAX_W,
};

export const MOBILE_TOP_BAR_HEIGHT = "54px";

/** Tab row height (icons + labels, excluding home-indicator safe area). */
export const MOBILE_BOTTOM_NAV_HEIGHT = "64px";

/** Full bottom nav footprint including home-indicator safe area. */
export const MOBILE_BOTTOM_NAV_TOTAL_HEIGHT = `calc(${MOBILE_BOTTOM_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px))`;

export const MOBILE_ACTION_BAR_HEIGHT = "44px";

/** Full explore action dock: button row + vertical padding. */
export const MOBILE_EXPLORE_ACTION_DOCK_HEIGHT = "60px";

/** Usable viewport below top bar and bottom nav (excludes safe area). */
export const MOBILE_SHELL_HEIGHT = `calc(100dvh - ${MOBILE_TOP_BAR_HEIGHT} - ${MOBILE_BOTTOM_NAV_TOTAL_HEIGHT})`;

/** Space reserved above the bottom nav for explore Next/Like controls. */
export const MOBILE_EXPLORE_ACTION_OFFSET = `calc(${MOBILE_BOTTOM_NAV_TOTAL_HEIGHT} + ${MOBILE_EXPLORE_ACTION_DOCK_HEIGHT})`;

/** Explore photo height on mobile — fills viewport below top bar and above action controls. */
export const MOBILE_EXPLORE_PHOTO_HEIGHT = `calc(100dvh - ${MOBILE_TOP_BAR_HEIGHT} - ${MOBILE_BOTTOM_NAV_TOTAL_HEIGHT} - ${MOBILE_EXPLORE_ACTION_DOCK_HEIGHT} - 8px)`;

/** Floating install prompt offset above the bottom nav. */
export const MOBILE_INSTALL_PROMPT_BOTTOM = `calc(${MOBILE_BOTTOM_NAV_HEIGHT} + env(safe-area-inset-bottom, 0px) + 8px)`;

/** Usable height under the sticky mobile top bar (includes safe-area top inset). */
export const MOBILE_BELOW_TOP_BAR_HEIGHT = `calc(100dvh - ${MOBILE_TOP_BAR_HEIGHT} - env(safe-area-inset-top, 0px))`;

/** Custom event: Get Started wizard should go to previous step (or navigate back on step 0). */
export const GET_STARTED_BACK_EVENT = "payinapo:get-started-back";
